import React, { useEffect } from "react";
import { Link, Navigate } from "react-router-dom";
import { useAssociationAuth } from "../../context/AssociationAuthContext";
import { DEST_ASSO, DEST_USER, destinationVersements } from "../../utils/versementsAiguillage";

// ─── /versements — adresse UNIQUE donnée à Stripe (28/09/2026) ───────────────
//
// Stripe écrit lui-même aux titulaires de comptes connectés quand il lui faut
// une information, avec un lien vers les « Site links » de la plateforme
// (Connect → Liens vers le site ; doc docs.stripe.com/connect/embedded-comms,
// lue le 28/09/2026). Ces liens valent pour TOUS les comptes : associations ET
// particuliers/pros. Or `/wallet` n'accepte pas une association (ProtectedRoute
// sans allowAsso) et `/association/dashboard` n'accepte pas un particulier.
// Cette page aiguille : association connectée → son onglet Versements ;
// utilisateur connecté → /wallet ; personne → choisir son espace.

export default function VersementsAiguillage({ user, loading }) {
  const { account: assoAccount, loading: assoLoading } = useAssociationAuth() || {};

  useEffect(() => {
    try {
      const robots = document.createElement("meta");
      robots.name = "robots";
      robots.content = "noindex";
      document.head.appendChild(robots);
      return () => { document.head.removeChild(robots); };
    } catch (_) { return undefined; }
  }, []);

  if (loading || assoLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="w-8 h-8 border-3 border-[#1DA1F2] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }
  const dest = destinationVersements({ assoAccount, user });
  if (dest) return <Navigate to={dest} replace />;

  const allerVersEspaceUtilisateur = () => {
    try { sessionStorage.setItem("gively_return_to", DEST_USER); } catch (_) { /* noop */ }
  };
  return (
    <main className="min-h-screen bg-slate-50 flex items-center justify-center px-4 pb-safe-nav">
      <div className="w-full max-w-md bg-white rounded-2xl border border-slate-200 p-6 space-y-4">
        <h1 className="text-lg font-bold text-slate-900">Accéder à vos versements</h1>
        <p className="text-sm text-slate-600">
          Connectez-vous à votre espace pour consulter votre compte de versement et, si notre
          partenaire de paiement Stripe le demande, compléter une information.
        </p>
        <Link
          to={`/association/login?next=${encodeURIComponent(DEST_ASSO)}`}
          className="block w-full text-center rounded-xl bg-[#1DA1F2] text-white text-sm font-semibold py-2.5 hover:bg-[#0d8ecf]"
          data-testid="versements-asso"
        >
          Je représente une association
        </Link>
        <Link
          to="/login"
          onClick={allerVersEspaceUtilisateur}
          className="block w-full text-center rounded-xl border border-slate-300 text-slate-800 text-sm font-semibold py-2.5 hover:bg-slate-50"
          data-testid="versements-utilisateur"
        >
          Je suis un particulier ou un professionnel
        </Link>
      </div>
    </main>
  );
}
